import {
    FilterCheckbox,
    FilterChipItemButton,
} from 'components/FilterAccordion';
import PresetFilterAccordionItem, {
    withPresetTooltip,
} from './PresetFilterAccordionItem';
import { createClusterFilters, createHealthStatFilters } from 'utils/presets';
import { GOOGLE_SORT_OPTIONS } from 'utils/metrics';

const risingOrFlatClusters = createClusterFilters([
    'sustained riser',
    'flat',
    'seasonal riser',
]);

const risingClusters = createClusterFilters([
    'sustained riser',
    'seasonal riser',
    'rising star',
]);

const sortOptionMoMIncreaseDescending = GOOGLE_SORT_OPTIONS.MoM_increase;
const sortOptionYoYIncreaseDescending = GOOGLE_SORT_OPTIONS.absoluteGrowth;

const presets = {
    trendingThisMonth: {
        value: 'trendingThisMonth',
        label: 'Trending This Month',
        definition:
            'Catch emerging search intent before it hits the mass market.',
        filters: {
            cluster: risingOrFlatClusters,
        },
        sortOption: sortOptionMoMIncreaseDescending,
    },
    trendingThisYear: {
        value: 'trendingThisYear',
        label: 'Trending This Year',
        definition:
            'Optimize for high-volume category pillars that are still gaining market share.',
        filters: {
            cluster: risingOrFlatClusters,
        },
        sortOption: sortOptionYoYIncreaseDescending,
    },
    whiteSpaceOpportunity: {
        value: 'whiteSpaceOpportunity',
        label: 'Whitespace Opportunity',
        definition:
            'Identify high-intent consumer needs with low brand saturation.',
        filters: {
            cluster: risingClusters,
            healthStats: createHealthStatFilters([
                ['average brand searches', [4, 6, 8]],
                ['average monthly searches', [2]],
            ]),
        },
        sortOption: sortOptionYoYIncreaseDescending,
    },
};

export const PresetFilterOption = withPresetTooltip(FilterCheckbox, presets);
const PresetFilterChipItemButton = withPresetTooltip(
    FilterChipItemButton,
    presets,
);

function GooglePresetFilterAccordionItem(props) {
    return (
        <PresetFilterAccordionItem
            presets={presets}
            FilterOption={PresetFilterOption}
            FilterChipItemButton={PresetFilterChipItemButton}
            {...props}
        />
    );
}

export default GooglePresetFilterAccordionItem;
